import { useEffect, useState } from 'preact/hooks';
import { listModels, metrics, info } from '../lib/api';
import { activeToken } from '../store/global';
import { PageHeader } from '../components/PageHeader';

export function Models() {
  const [models, setModels] = useState<unknown>(null);
  const [mets, setMets] = useState<unknown>(null);
  const [infoData, setInfoData] = useState<unknown>(null);

  useEffect(() => {
    if (!activeToken.value) return;
    Promise.all([listModels().catch(() => null), metrics().catch(() => null), info().catch(() => null)]).then(([m, mm, ii]) => {
      setModels(m);
      setMets(mm);
      setInfoData(ii);
    });
  }, [activeToken.value]);

  return (
    <div class="mx-auto max-w-7xl px-6 py-6">
      <PageHeader
        title="Modelos"
        description="Modelos disponíveis e métricas do AgentOS."
        icon={<i class="ph ph-cpu text-xl" />}
      />

      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Block title="Models">
          <Json data={models} />
        </Block>
        <Block title="Info">
          <Json data={infoData} />
        </Block>
        <Block title="Metrics" wide>
          <Json data={mets} />
        </Block>
      </div>
    </div>
  );
}

function Block({ title, children, wide }: { title: string; children: preact.ComponentChildren; wide?: boolean }) {
  return (
    <div class={`rounded-lg border border-border bg-card text-card-foreground shadow-sm overflow-hidden ${wide ? 'md:col-span-2' : ''}`}>
      <div class="px-3 py-2 border-b border-border bg-muted text-xs font-medium text-muted-foreground">
        {title}
      </div>
      <div class="p-3">{children}</div>
    </div>
  );
}

function Json({ data }: { data: unknown }) {
  if (data == null) return <p class="text-xs text-muted-foreground">—</p>;
  return (
    <pre class="text-xs font-mono tabular-nums whitespace-pre-wrap break-all max-h-96 overflow-auto">
{JSON.stringify(data, null, 2)}
    </pre>
  );
}
